import NavigationBottom from "./NavigationBottom";
import NavigationTop from "./NavigationTop";
import styles from './Header.module.css'
function NavigationMain
(){
    return <div>
        
<NavigationTop/>

    </div>
}
export default NavigationMain
;